export default "__VITE_ASSET__BcjsRgUG__"